
import { useState, useEffect } from 'react';

interface WeatherData {
  temperature: number;
  condition: string;
  humidity: number;
  windSpeed: number;
  icon: string;
}

export default function WeatherWidget() {
  const [weather, setWeather] = useState<WeatherData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate weather API call with realistic Kilimanjaro weather data
    const fetchWeather = () => {
      setTimeout(() => {
        const conditions = [
          { temp: 22, condition: 'Partly Cloudy', humidity: 65, wind: 8, icon: 'ri-cloudy-line' },
          { temp: 25, condition: 'Sunny', humidity: 55, wind: 12, icon: 'ri-sun-line' },
          { temp: 18, condition: 'Light Rain', humidity: 85, wind: 15, icon: 'ri-drizzle-line' },
          { temp: 20, condition: 'Overcast', humidity: 70, wind: 10, icon: 'ri-cloudy-2-line' }
        ];
        
        const randomCondition = conditions[Math.floor(Math.random() * conditions.length)];
        setWeather({
          temperature: randomCondition.temp,
          condition: randomCondition.condition,
          humidity: randomCondition.humidity,
          windSpeed: randomCondition.wind,
          icon: randomCondition.icon
        });
        setLoading(false);
      }, 1000);
    };

    fetchWeather();
    
    // Update weather every 10 minutes
    const interval = setInterval(fetchWeather, 600000);
    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return (
      <div className="bg-white rounded-lg p-6 shadow-lg border border-gray-100">
        <div className="animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-32 mb-4"></div>
          <div className="h-8 bg-gray-200 rounded w-24 mb-2"></div>
          <div className="h-4 bg-gray-200 rounded w-40"></div>
        </div>
      </div>
    );
  }

  if (!weather) return null;

  return (
    <div className="bg-white rounded-lg p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Kilimanjaro Weather</h3>
        <i className={`${weather.icon} text-2xl text-blue-500`}></i>
      </div>
      
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <span className="text-3xl font-bold text-gray-900">{weather.temperature}°C</span>
          <span className="text-sm text-gray-600">{weather.condition}</span>
        </div>
        
        <div className="grid grid-cols-2 gap-4 pt-3 border-t border-gray-100">
          <div className="flex items-center gap-2">
            <i className="ri-drop-line text-blue-400"></i>
            <div>
              <p className="text-xs text-gray-500">Humidity</p>
              <p className="text-sm font-medium">{weather.humidity}%</p>
            </div>
          </div>
          
          <div className="flex items-center gap-2">
            <i className="ri-windy-line text-green-400"></i>
            <div>
              <p className="text-xs text-gray-500">Wind</p>
              <p className="text-sm font-medium">{weather.windSpeed} km/h</p>
            </div>
          </div>
        </div>
        
        <p className="text-xs text-gray-400 text-center pt-2 border-t border-gray-100">
          Updated every 10 minutes
        </p>
      </div>
    </div>
  );
}
